import { lazy } from 'react';

export const staffCmsModalComponentByType = {
  SELECT_CONTENT_BLOCK: lazy(() =>
    import('./SelectContentBlock/SelectContentBlockModalContainer').then(
      (module) => ({ default: module.SelectContentBlockModalContainer }),
    ),
  ),
  DELETE_SUBSITE: lazy(() =>
    import('./DeleteSubsite/StaffCmsDeleteSubsiteModal').then((module) => ({
      default: module.StaffCmsDeleteSubsiteModal,
    })),
  ),
  DUPLICATE_CONTENT: lazy(() =>
    import('./DuplicateContent/StaffCmsDuplicateContentModalContainer').then(
      (module) => ({ default: module.StaffCmsDuplicateContentModalContainer }),
    ),
  ),
} as const satisfies Record<string, unknown>;
